<template>
  <div :class="['cenario-corpo', { 'cenario-corpo-compensacao-multiplos': id != 1 }]">
    <div>
      <CenarioTitulo titulo="OPERAÇÃO" />
      <CenarioCorpoOperacao
        :filtros="filtros"
        :dadosForm="dadosForm"
        :validaCampos="validaCampos"
        :exibeValidacao="exibeValidacao"
        :numeroCenarios="numeroCenarios"
        :calculaDadosForm="calculaDadosForm"
      />
    </div>
    <div v-if="dadosForm.tipoOperacao != 41">
      <CenarioTitulo titulo="REMETENTE" />
      <CenarioCorpoRemetente
        :id="id"
        :filtros="filtros"
        :dadosForm="dadosForm"
        :listaCnae="listaCnae"
        :payloadCnae="payloadCnae"
        :calculaDados="calculaDados"
        :verificaCNPJ="verificaCNPJ"
        :validaCampos="validaCampos"
        :numeroCenarios="numeroCenarios"
        :exibeValidacao="exibeValidacao"
        :elementoCriado="elementoCriado"
        :calculaDadosForm="calculaDadosForm"
        :impedimentoSnRes="impedimentoSnRes"
        :carregandoAlgumaCnae="carregandoAlgumaCnae"
        :openModalCnaeCompreende="openModalCnaeCompreende"
      />
    </div>
    <div v-if="dadosForm.tipoOperacao != 46">
      <CenarioTitulo titulo="DESTINATÁRIO" />
      <CenarioCorpoDestinatario
        :id="id"
        :filtros="filtros"
        :dadosForm="dadosForm"
        :listaCnae="listaCnae"
        :payloadCnae="payloadCnae"
        :calculaDados="calculaDados"
        :verificaCNPJ="verificaCNPJ"
        :validaCampos="validaCampos"
        :exibeValidacao="exibeValidacao"
        :numeroCenarios="numeroCenarios"
        :calculaDadosForm="calculaDadosForm"
        :impedimentoSnDes="impedimentoSnDes"
        :carregandoAlgumaCnae="carregandoAlgumaCnae"
        :openModalCnaeCompreende="openModalCnaeCompreende"
      />
    </div>
    <div v-if="exibeMercadoria">
      <CenarioTitulo titulo="MERCADORIA" />
      <CenarioCorpoMercadoria
        :filtros="filtros"
        :dadosForm="dadosForm"
        :calculaDados="calculaDados"
        :validaCampos="validaCampos"
        :exibeValidacao="exibeValidacao"
        :numeroCenarios="numeroCenarios"
        :calculaDadosForm="calculaDadosForm"
      />
    </div>
    <div>
      <CenarioTitulo />
      <CenarioBotoes
        class="no-print"
        :id="id"
        :dadosForm="dadosForm"
        :nomeCenario="nomeCenario"
        :travaBotoes="travaBotoes"
        :carregaSalvar="carregaSalvar"
        :numeroCenarios="numeroCenarios"
        :buscarResultado="buscarResultado"
        :resultadoExibido="resultadoExibido"
        :imprimirResultado="imprimirResultado"
        :submitSalvarCenario="submitSalvarCenario"
      />
    </div>
  </div>
</template>

<script>
import CenarioInput from "../CenarioInput/CenarioInput.vue";
import CenarioTitulo from "./CenarioTitulo.vue";
import CenarioBotoes from "./CenarioBotoes.vue";
import CenarioCorpoOperacao from "./CenarioCorpoOperacao.vue";
import CenarioCorpoRemetente from "./CenarioCorpoRemetente.vue";
import CenarioCorpoMercadoria from "./CenarioCorpoMercadoria.vue";
import CenarioCorpoDestinatario from "./CenarioCorpoDestinatario.vue";

import { mapGetters } from "vuex";

export default {
  name: "CenarioCorpo",

  components: {
    CenarioInput,
    CenarioTitulo,
    CenarioBotoes,
    CenarioCorpoOperacao,
    CenarioCorpoRemetente,
    CenarioCorpoMercadoria,
    CenarioCorpoDestinatario
  },

  props: {
    travaBotoes: Boolean,
    carregaSalvar: Boolean,
    exibeValidacao: Boolean,
    elementoCriado: Boolean,
    impedimentoSnRes: Boolean,
    impedimentoSnDes: Boolean,
    resultadoExibido: Boolean,
    carregandoAlgumaCnae: Boolean,
    nomeCenario: String,
    id: Number,
    numeroCenarios: Number,
    calculaDados: Function,
    verificaCNPJ: Function,
    buscarResultado: Function,
    calculaDadosForm: Function,
    imprimirResultado: Function,
    submitSalvarCenario: Function,
    openModalCnaeCompreende: Function,
    listaNcm: Array,
    filtros: Object,
    listaCnae: Object,
    dadosForm: Object,
    validaCampos: Object
  },

  watch: {
    // LIMPA DADOS CONFORME MUDA TIPO DE OPERAÇÃO
    "dadosForm.tipoOperacao": {
      deep: true,
      handler() {
        if (this.dadosForm.tipoOperacao == 41) {
          this.calculaDadosForm("", "cnpjRemetente");
          this.calculaDadosForm("", "atividadeRemetente");
          this.calculaDadosForm("", "regimeRemetente");
          this.calculaDadosForm("", "cnaeRemetente");
          this.calculaDadosForm("", "origem");
          this.calculaDadosForm("", "destinacao");
          this.calculaDadosForm("1", "sabeCNPJDestinatario");
        }
        if (this.dadosForm.tipoOperacao == 46) {
          this.calculaDadosForm("", "cnpjDestinatario");
          this.calculaDadosForm("", "atividadeDestino");
          this.calculaDadosForm("", "tipoAtividade");
          this.calculaDadosForm("", "regimeDestinatario");
          this.calculaDadosForm("", "cnaeDestinatario");
          this.calculaDadosForm("", "origem");
          this.calculaDadosForm("", "destinacao");
        }
        if (this.dadosForm.tipoOperacao != 41) {
          this.calculaDadosForm("0", "sabeCNPJDestinatario");
        }
      }
    }
  },

  computed: {
    ...mapGetters("empresa", ["getEmpresa"]),
    // VERIFICA SE EXIBE O QUADRO DE MERCADORIAS
    exibeMercadoria() {
      if (["", "39", "40"].includes(this.dadosForm.tipoOperacao)) {
        return true;
      }
      if (
        this.dadosForm.tipoOperacao == 41 &&
        (["47", "48", "49"].includes(this.dadosForm.atividadeDestino) ||
          (["50", "51"].includes(this.dadosForm.atividadeDestino) &&
            this.dadosForm.tipoAtividade != ""))
      ) {
        return true;
      }
      return false;
    },
    // ALTERA O PAYLOAD DA CNAE CONFORME NECESSÁRIO
    payloadCnae() {
      let actionR = null;
      let actionD = null;
      let empresaR = null;
      let empresaD = null;
      switch (this.dadosForm.tipoOperacao) {
        case "46":
          actionR =
            this.dadosForm.cnpjRemetente != "" &&
            this.dadosForm.cnpjRemetente != this.getEmpresa.cnpj
              ? 4
              : this.getEmpresa.id != ""
              ? 3
              : 0;
          actionD = !!this.dadosForm.sabeCNPJDestinatario ? 5 : null;
          empresaR =
            this.dadosForm.cnpjRemetente != "" &&
            this.dadosForm.cnpjRemetente != this.getEmpresa.cnpj
              ? this.dadosForm.cnpjRemetente
              : this.getEmpresa.id != ""
              ? this.getEmpresa.id
              : null;
          empresaD = null;
          break;
        case "41":
          actionR = this.dadosForm.cnpjDestinatario != "" ? 4 : 0;
          actionD = this.dadosForm.cnpjDestinatario != "" ? 6 : 5;
          empresaR = this.dadosForm.cnpjDestinatario != "" ? this.dadosForm.cnpjDestinatario : null;
          empresaD = this.dadosForm.cnpjDestinatario != "" ? this.dadosForm.cnpjDestinatario : null;
          break;
        case "40":
          actionR =
            this.dadosForm.cnpjRemetente != "" &&
            this.dadosForm.cnpjRemetente != this.getEmpresa.cnpj
              ? 4
              : this.getEmpresa.id != ""
              ? 3
              : 0;
          actionD = this.dadosForm.cnpjDestinatario != "" ? 6 : 5;
          empresaR =
            this.dadosForm.cnpjRemetente != "" &&
            this.dadosForm.cnpjRemetente != this.getEmpresa.cnpj
              ? this.dadosForm.cnpjRemetente
              : this.getEmpresa.id != ""
              ? this.getEmpresa.id
              : null;
          empresaD = this.dadosForm.cnpjDestinatario != "" ? this.dadosForm.cnpjDestinatario : null;
          break;
        case "39":
          actionR =
            this.dadosForm.cnpjRemetente != "" &&
            this.dadosForm.cnpjRemetente != this.getEmpresa.cnpj
              ? 4
              : this.getEmpresa.id != ""
              ? 3
              : 0;
          actionD = this.dadosForm.cnpjDestinatario != "" ? 6 : 5;
          empresaR =
            this.dadosForm.cnpjRemetente != "" &&
            this.dadosForm.cnpjRemetente != this.getEmpresa.cnpj
              ? this.dadosForm.cnpjRemetente
              : this.getEmpresa.id != ""
              ? this.getEmpresa.id
              : null;
          empresaD = this.dadosForm.cnpjDestinatario != "" ? this.dadosForm.cnpjDestinatario : null;
          break;
        default:
          actionR =
            this.dadosForm.cnpjRemetente != "" &&
            this.dadosForm.cnpjRemetente != this.getEmpresa.cnpj
              ? 4
              : this.getEmpresa.id != ""
              ? 3
              : 0;
          actionD = this.dadosForm.cnpjDestinatario != "" ? 6 : 5;
          empresaR =
            this.dadosForm.cnpjRemetente != "" &&
            this.dadosForm.cnpjRemetente != this.getEmpresa.cnpj
              ? this.dadosForm.cnpjRemetente
              : this.getEmpresa.id != ""
              ? this.getEmpresa.id
              : null;
          empresaD = this.dadosForm.cnpjDestinatario != "" ? this.dadosForm.cnpjDestinatario : null;
          break;
      }
      let payload = {
        ncm: this.dadosForm.ncm,
        actionR: actionR,
        actionD: actionD,
        empresaR: empresaR,
        empresaD: empresaD,
        ncm_cliente: this.listaNcm.map(p => p.value)
      };
      return payload;
    }
  }
};
</script>

<style lang="scss" scoped>
.cenario-corpo {
  border-radius: 0 0 10px 10px;
  background: var(--cinza02);
  border: 1px dashed #d4d4d4;
  border-top: none;
  padding: 1rem 1.5rem 0 1.5rem;
}
.cenario-corpo-compensacao-multiplos {
  margin-bottom: 45px;
}
</style>
